import { useEffect, useState } from 'react';
import DocumentItem from './document-item';
import { ApplicationDocumentRowTypes } from '../types';

import cn from '../new-application.module.css';

const DocumentRow = ({
  title,
  optional,
  documents,
  applicationId,
  onSelect,
  search,
  applicationStatus,
  error,
  clearErrors,
  categoryId,
  categoryName,
  setRenamePopupVisible,
  setSelectedDocument,
  renameAvailable,
  isIndividual,
  isCof,
}: ApplicationDocumentRowTypes) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (documents && documents.length) {
      setExpanded(true);
    }
  }, [documents]);

  useEffect(() => {
    if (error && documents?.length) {
      clearErrors([categoryId as string, categoryName as string]);
    }
  }, [error, documents]);

  return (
    <div className={cn.documentsRow}>
      <div className={cn.documentRowTitle}>
        {title}
        {optional && <span>(optional)</span>}
        <button
          type="button"
          className={cn.expandButton}
          aria-label="Expand Button"
          onClick={() => setExpanded(!expanded)}
        />
        {error && <div className={cn.sumsubError}>{error}</div>}
      </div>
      {expanded && documents && documents.length > 0 && (
        <div className={cn.documentItems}>
          {documents.map((item) => (
            <DocumentItem
              key={item.id}
              document={item}
              onSelect={onSelect}
              applicationId={applicationId}
              applicationStatus={applicationStatus}
              search={search}
              setRenamePopupVisible={setRenamePopupVisible}
              setSelectedDocument={setSelectedDocument}
              renameAvailable={renameAvailable}
              isIndividual={isIndividual}
              isCof={isCof}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default DocumentRow;
